<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />

    <v-layout wrap justify-center>
      <v-flex xs12 sm12 md12 lg10 xl10 text-center id="product_container" pb-2>
        <v-layout wrap justify-center pt-6 hidden-lg-and-up>
          <v-flex xs12 py-2>
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs12 sm4 md3 px-4> 
            <v-form @submit.prevent="appSearch">
              <v-text-field
                class="searchBox"
                v-model="searchKey"
                prepend-inner-icon="mdi-magnify"
                placeholder="Search for products"
                single-line
                dense
                solo
                flat
                hide-details
                color="#FF0F0F"
              ></v-text-field>
            </v-form>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex xs12>
            <SubCategorySlider />
          </v-flex>
        </v-layout>
        <template v-if="products.length > 0">
          <v-layout wrap justify-start pr-1>
            <v-flex
              xs6
              sm3
              md2
              pl-2
              py-1
              :pl-1="i % 2 == 0 ? true : false"
              :pr-1="i % 2 != 0 ? true : false"
              pa-md-5
              v-for="(item, i) in products"
              :key="i"
            >
              <v-card
                :outlined="
                  $vuetify.breakpoint.name == 'xs' ||
                  $vuetify.breakpoint.name == 'sm'
                    ? true
                    : false
                "
                tile
                flat
                :max-width="widthOfCard"
                :ripple="false"
                @click="
                  $router.push('/Products/' + item.productname + '/' + item._id)
                "
              >
                <Product v-bind:product="item" />
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-center>
            <v-flex xs12 text-center align-self-end v-if="pages > 1">
              <v-pagination
                v-model="currentPage"
                :length="pages"
                :total-visible="7"
                color="#FF3434"
              />
            </v-flex>
          </v-layout>
        </template>
        <v-layout wrap justify-center v-else>
          <v-flex xs12 pa-2 align-self-center>
            <span
              style="
                font-family: poppinsregular;
                font-size: 25px;
                color: #000000;
                cursor: pointer;
              "
              >Oops! No Products Found</span
            >
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm12 md12 lg2 xl2 hidden-md-and-down>
        <!-- <v-navigation-drawer
          class="fixedSidebar"
          v-model="sideNav2"
          clipped
          height="100vh"
          permanent
          color="#FFFFFF"
        > -->
        <v-layout wrap justify-center>
          <v-flex xs12>
            <SideBar :styleId="$route.query.styl" />
          </v-flex>
        </v-layout>
        <!-- </v-navigation-drawer> -->
      </v-flex>
      <v-flex xs12 sm12 md12 lg2 xl2 hidden-lg-and-up>
        <SideBar :styleId="$route.query.styl" />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import SideBar from "./sideBar";
import SubCategorySlider from "./subCategorySlider";
export default {
  components: {
    SideBar,
    SubCategorySlider,
  },
  // metaInfo() {
  //   return {
  //     title: "product",
  //     titleTemplate: "%s | vue-meta Example App",
  //     meta: [
  //       {
  //         vmid: "product",
  //         name: "product",
  //         content:
  //           "hello world, this is an example of adding a product with vueMeta",
  //       },
  //       { charset: "utf-8" },
  //       {
  //         name: "description",
  //         content: "An example Vue application with vue-meta.",
  //       },
  //       {
  //         name: "keywords",
  //         content:
  //           "online shopping, online shopping kerala, fashion store, offers in kerala, ",
  //       },
  //     ],
  //   };
  // },
  data() {
    return {
      sideNav2: true,
      ServerError: false,
      sideNav: true,
      searchKey: null,
      products: [],
      totalData: 0,
      pages: 0,
      // count: 18,
      count: 30,
      currentPage: this.$route.query.page ? Number(this.$route.query.page) : 1,
      widthOfCard: "250px",
      type: "Styl",
    };
  },
  watch: {
    currentPage() {
      this.$router.push({
        path: "/Products",
        query: {
          styl: this.$route.query.styl,
          category: this.$route.query.category,
          subcategory: this.$route.query.subcategory,
          searchKey: this.$route.query.searchKey,
          page: this.currentPage,
        },
      });
    },
  },
  // beforeMount() {
  //   this.searchKey = this.$route.query.searchKey;
  //   this.type = this.$route.query.type;
  //   this.getData();
  // },
  methods: {
    urlEncodeFunc(item) {
  var res = encodeURIComponent(item);
  return res
},
    getData() {
      this.appLoading = true;
      var page = null;
      if (this.$route.query.page) page = Number(this.$route.query.page);
      axios({
        method: "GET",
        url: "/product/all",
        params: {
          category: this.$route.query.category,
          styl: this.$route.query.styl,
          subcategory: this.$route.query.subcategory,
          keyword: this.$route.query.searchKey,
          page: page,
          count: this.count,
          type:"minimized",
          // sort: this.sortType,
          currenttype: this.type,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
            this.pages = response.data.pages;
            this.totalData = response.data.count;
          } else {
            this.products = [];
          }
          this.loadData = true;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    appSearch() {
      if (this.$route.query.searchKey != this.searchKey) {
        this.$router.push({
          path: "/Products",
          query: {
            styl: this.$route.query.styl,
            category: this.$route.query.category,
            subcategory: this.$route.query.subcategory,
            searchKey: this.searchKey,
            page: this.$route.query.page,
          },
        });
      } else {
        return;
      }
    },
  },
};
</script>
<style scoped>
#product_container {
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
}

/* width */
::-webkit-scrollbar {
  width: 1px !important;
  height: 1px !important;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0px grey !important;
  border-radius: 5px !important;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: transparent !important;
  border-radius: 5px !important;
}
</style>